var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.disabled)?_c('span',{class:_vm.disabledButtonClasses},[_c('i',{staticClass:"fas fa-trash"})]):_vm._e(),_vm._v(" "),(!_vm.disabled)?_c('call-dialog-link',{attrs:{"id":_vm.id,"route":_vm.route,"message":_vm.message,"css-class":_vm.buttonClasses}},[_c('i',{staticClass:"fas fa-trash"})]):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d8c3be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/src/components/Triggers/RemoveDialogButton.vue
// module id = W7/H
// module chunks = 0 1